import { viewAlert } from "../apis";
import actions from "../actions/appActions";
export var viewAlertInitiated = function viewAlertInitiated(alertId, alertsApiBaseUrl, pathprefix, callback) {
  return function (dispatch) {
    return viewAlert({
      apiBaseUrl: alertsApiBaseUrl,
      pathprefix: pathprefix,
      payload: {
        alertId: alertId
      }
    }).then(function (response) {
      callback();
      dispatch(viewAlertSucceeded(alertId));
    })["catch"](function (e) {
      dispatch(viewAlertFailed());
    });
  };
};
export var viewAlertSucceeded = function viewAlertSucceeded(viewedAlertId) {
  return {
    type: actions.viewAlertSucceeded,
    payload: {
      viewedAlertId: viewedAlertId
    }
  };
};
export var viewAlertFailed = function viewAlertFailed() {
  return {
    type: actions.viewAlertFailed,
    payload: {}
  };
};
export var setAccessTokenApiPath = function setAccessTokenApiPath(apiPath) {
  return {
    type: "SET_ACCESS_TOKEN_API",
    payload: {
      accessTokenApiPath: apiPath
    }
  };
};